import { setEntity, setEntities } from "../SessionManagement/actionCreators"
import { openSidebar, closeSidebar } from "../Sidebar/actionCreators"

export const mapState = (state, ownProps) => ({
  loggedIn: ownProps.loggedIn,
  userPool: state.sessionReducer.userPool,
  firstName: state.sessionReducer.idTokenPayload.given_name,
  lastName: state.sessionReducer.idTokenPayload.family_name,
  role: state.sessionReducer?.userDetails?.role,
  NavbarElements: state.navbarReducer.navbarElements,
  className: state.navbarReducer.className,
  entity_id: state.sessionReducer.entity_id,
  entities: state.sessionReducer.entities,
  isSidebarOpen: state.sidebarReducer?.isOpen,
  idTokenEntityId: state.sessionReducer.idTokenPayload["custom:entity_id"],
})

export const mapDispatch = (dispatch) => ({
  setEntity: (entity) => dispatch(setEntity(entity)),
  setEntities: (entities) => dispatch(setEntities(entities)),
  openSidebar: () => dispatch(openSidebar()),
  closeSidebar: () => dispatch(closeSidebar()),
})
